<ion-content>
  <ion-grid>
    <ion-row>
      <ion-col size="12" class="back-bar">
        <ion-toolbar>
          <ion-back-button
            slot="start"
            color="tertiary"
            text="Back"
            defaultHref="''"
          ></ion-back-button>
        </ion-toolbar>
      </ion-col>
    </ion-row>
  </ion-grid>
  <ion-grid class="grid-container">
    <ion-row>
      <ion-col size="12" class="update-note"
        ><div>Last update: 11.07.2023</div></ion-col
      >
      <ion-col size="12" style="padding-top: 0"
        ><div><h1>Cookie Policy</h1></div></ion-col
      >
      <ion-col size="12" style="padding-top: 7px; padding-bottom: 0"
        ><div>
          <h2>What are cookies?</h2>
        </div>
        <div>
          <p>
            This Cookie Policy explains what cookies are and how we use them,
            the types of cookies we use i.e, the information we collect using
            cookies and how that information is used, and how to manage the
            cookie settings.
          </p>
        </div>
        <div>
          <p>
            Cookies are files saved on your device when you visit a website or
            web application. We use cookies to collect and store information
            about how you use Cloudia. These cookies help us make the
            application function properly, make it more secure, provide better
            user experience, and understand how the Cloudia performs and to
            analyze what works and where it needs improvement.
          </p>
        </div></ion-col
      >
      <ion-col size="12" style="padding-top: 16px; padding-bottom: 0"
        ><div>
          <h2>How do we use cookies?</h2>
        </div>
        <div>
          <p>
            Similar to many online services, our web application utilizes both
            first-party and third-party cookies for various purposes.
            First-party cookies are primarily essential for the proper
            functioning of the website and do not gather any personally
            identifiable information about you.
          </p>
        </div>
        <div>
          <p>
            On the other hand, the third-party cookies employed on our web
            application serve primarily to assess the website's performance,
            monitor your interactions with Cloudia, enhance security, and
            overall provide an enhanced user experience.
          </p>
        </div></ion-col
      >
      <ion-col size="12" style="padding-top: 16px"
        ><div style="margin-bottom: 40px"><h2>Types of Cookies we use</h2></div>
        <div><h3>Analytical cookies</h3></div>
        <div>
          <ion-row class="table-header-row">
            <ion-col size="5">Name</ion-col>
            <ion-col size="2">Duration</ion-col>
            <ion-col size="5">Description</ion-col>
          </ion-row>
          <ion-row *ngFor="let row of analyticalCookies" class="table-data-row">
            <ion-col size="5">{{ row.name }}</ion-col>
            <ion-col size="2">{{ row.duration }}</ion-col>
            <ion-col size="5">{{ row.description }}</ion-col></ion-row
          >
        </div>
        <div style="padding-top: 25px"><h3>Strictly necessary cookies</h3></div>
        <div>
          <ion-row class="table-header-row">
            <ion-col size="5">Name</ion-col>
            <ion-col size="2">Duration</ion-col>
            <ion-col size="5">Description</ion-col>
          </ion-row>
          <ion-row *ngFor="let row of necassaryCookies" class="table-data-row">
            <ion-col size="5">{{ row.name }} </ion-col>
            <ion-col size="2">{{ row.duration }}</ion-col>
            <ion-col size="5">{{ row.description }}</ion-col></ion-row
          >
        </div>
      </ion-col>
      <ion-col size="12" style="padding-bottom: 8px"
        ><div><h2>Manage cookie preferences</h2></div>
        <div>
          <p style="margin-bottom: 0">
            You can change your cookie preferences any time by clicking the
            button below. This will let you revisit the cookie consent banner
            and change your preferences or withdraw your consent right away.
          </p>
        </div></ion-col
      >
      <ion-col size="12" style="padding-top: 8px; padding-bottom: 8px"
        ><div>
          <ion-button
            href="{{ '/' + tenant + '/user-settings#cookie-settings' }}"
            >Cookie preferences</ion-button
          >
        </div></ion-col
      >
      <ion-col size="12" style="padding-top: 8px"
        ><div>
          <p style="margin-top: 0">
            In addition to this, different browsers provide different methods to
            block and delete cookies used by websites. You can change the
            settings of your browser to block/delete the cookies. Listed below
            are the links to the support documents on how to manage and delete
            cookies from the major web browsers.
          </p>
          <p>
            Chrome:
            <a
              class="cookie-manage-helper"
              href="https://support.google.com/accounts/answer/32050"
              target="_blank"
              >https://support.google.com/accounts/answer/32050</a
            >
          </p>
          <p>
            Safari:
            <a
              class="cookie-manage-helper"
              href="https://support.apple.com/en-in/guide/safari/sfri11471/mac"
              target="_blank"
              >https://support.apple.com/en-in/guide/safari/sfri11471/mac</a
            >
          </p>
          <p>
            Firefox:
            <a
              class="cookie-manage-helper"
              href="https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox"
              target="_blank"
              >https://support.mozilla.org/en-US/kb/clear-cookies-and-site-data-firefox</a
            >
          </p>
          <p>
            Microsoft Edge:
            <a
              class="cookie-manage-helper"
              href="https://www.microsoft.com/en-us/edge/learning-center/how-to-manage-and-clear-your-cache-and-cookies?form=MA13I2"
              target="_blank"
              >https://www.microsoft.com/en-us/edge/learning-center/how-to-manage-and-clear-your-cache-and-cookies?form=MA13I2</a
            >
          </p>
          <p>
            If you are using any other web browser, please visit your browser’s
            official support documents.
          </p>
        </div></ion-col
      >
    </ion-row>
  </ion-grid>
</ion-content>
